<template>
  <header class="site-header bg-white">
    <BannerComponent :banner="banner" />

    <div class="header-spacer" :class="{ 'has-banner': banner && !isFixed }">
      <transition name="mobile-nav-fade">
        <nav
          v-if="showMobileNav"
          class="mobile-nav d-lg-none"
          :class="{ 'has-banner': banner && !isFixed }"
          aria-label="Mobile Navigation"
          @click.self="toggleMobileNav"
        >
          <ul class="mobile-navbar-nav">
            <li v-for="(menuItem, index) in menuItems" :key="menuItem.id" class="mobile-nav-item">
              <a
                class="mobile-nav-link"
                :href="menuItem.url || '#'"
                @click="handleMobileNavClick(menuItem, index, $event)"
              >
                {{ menuItem.label }}
                <span v-if="menuItem.children && menuItem.children.length > 0" class="mobile-arrow">
                  <svg width="16" height="16" viewBox="0 0 16 16">
                    <path d="M4 6l4 4 4-4" stroke="#1e347d" stroke-width="2" fill="none" />
                  </svg>
                </span>
              </a>
              <ul
                v-if="mobileOpenIndex === index && menuItem.children && menuItem.children.length > 0"
                class="mobile-submenu"
              >
                <li v-for="subMenuItem in menuItem.children" :key="subMenuItem.id">
                  <a
                    class="mobile-submenu-link"
                    :href="subMenuItem.url || '#'"
                    :target="subMenuItem.targetBlank ? '_blank' : '_self'"
                    :rel="getRelAttributes(subMenuItem)"
                    @click="toggleMobileNav"
                  >
                    {{ subMenuItem.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        
      </transition>

      <div
        class="single-header-content"
        :class="{ 'has-banner': banner && !isFixed, 'is-fixed': isFixed && !$isMobile }"
      >
        <!-- Hamburger menu for mobile (now inside header for scroll) -->
       
        <button
          v-if="!showMobileNav"
          class="hamburger-menu d-lg-none"
          @click="toggleMobileNav"
          type="button"
          aria-label="Open navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <!-- Close Icon (shown when menu is open) -->
        <button
          v-else
          class="hamburger-menu close-icon d-lg-none"
          @click="toggleMobileNav"
          type="button"
          aria-label="Close navigation"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="#1e347d" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>

        <div class="alpha-top" v-show="!isFixed">
          <div class="brand-logo" @click.prevent="GoToDashboard">
            <img :src="logo" class="logo-site" alt="Site Logo" />
          </div>

          <div :class="[banner && !isFixed ? 'banner-top' : 'no-banner-top', { 'class-down': isFixed }]">
            <!-- User Info -->
            <div class="user-info account-block me-2">
              <router-link
                to="/mon-compte"
                class="blue-color text-decoration-none"
                :class="{ 'd-block': user.role == 'veterinaire', 'd-flex': user.role == 'client' }"
              >
                <div class="d-flex gap-2 align-items-center" style="max-height: 20px">
                  <img :src="iconuser" alt="User Icon" />
                  <template v-if="user.role == 'veterinaire'">
                    <span class="px-1 font-bold d-none d-md-inline">{{ $t("header.clinic") }}</span>
                  </template>
                  <div v-else class="d-none d-md-block">
                    <span class="px-1 font-bold">{{ $t("header.hello") }}</span>
                    <span class="px-1 font-bold">{{ user.gender }} {{ user.fullName }}</span>
                  </div>
                </div>
              </router-link>
            </div>

            <!-- Cart & Favorites -->
            <div class="cart-menu d-flex">
              <div class="sinlge-bar shopping me-2 me-lg-3" @click.prevent="GoToFavorites">
                <a href="#" class="single-icon position-relative text-decoration-none">
                  <img :src="iconfav" alt="Favorites" />
                  <span class="total-count" v-if="CountFavorite > 0">{{ CountFavorite }}</span>
                </a>
              </div>
              <div class="sinlge-bar shopping" @click.prevent="GoToCart">
                <a href="#" class="single-icon position-relative text-decoration-none">
                  <img :src="iconcart" alt="Cart" />
                  <span class="total-count" v-if="CountCart > 0">{{ CountCart }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="beta-top">
          <div :class="{ 'first-part': banner && !isFixed, 'second-part': isFixed }" class="first-part">
            <div class="brand-logo" @click.prevent="GoToDashboard" v-show="isFixed">
              <img :src="logo" class="logo-site" alt="Site Logo" />
            </div>

            <div class="header-nav-block">
              <nav class="navbar navbar-expand-lg position-relative">
                <div class="container-fluid px-0">
                  <ul class="navbar-nav">
                    <template v-for="(menuItem, index) in menuItems" :key="menuItem.id">
                      <li
                        class="nav-item dropdown position-relative"
                        @mouseenter="showMegaMenu(index)"
                        @mouseleave="hideMegaMenu"
                      >
                        <a class="nav-link dropdown-toggle d-flex align-items-center gap-1" :href="menuItem.url || '#'">
                          {{ menuItem.label }}
                          <span v-if="menuItem.children && menuItem.children.length > 0">
                            <img
                              :src="arrowdown"
                              alt="arrow down"
                              :class="['arrow-icon', { 'rotate-180': activeMegaMenu === index }]"
                            />
                          </span>
                        </a>
                        <div
                          class="dropdown-menu mega-menu"
                          :class="banner && !isFixed ? 'position-fixed' : 'position-no-banner'"
                          v-if="menuItem.children && menuItem.children.length > 0 && activeMegaMenu === index"
                        >
                          <div class="container-fluid px-3 px-lg-4">
                            <div class="menu-links py-3">
                              <template v-for="subMenuItem in menuItem.children" :key="subMenuItem.id">
                                <a
                                  class="dropdown-item py-2"
                                  :href="subMenuItem.url || '#'"
                                  :target="subMenuItem.targetBlank ? '_blank' : '_self'"
                                  :rel="getRelAttributes(subMenuItem)"
                                >
                                  {{ subMenuItem.label }}
                                </a>
                              </template>
                            </div>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </nav>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <div class="form-search-header" ref="SearchInput">
              <div class="position-relative w-100">
            <input type="text" style="display: none;" autocomplete="new-email" name="fake-email" />
              <input type="password" style="display: none;" autocomplete="new-password" name="fake-password" />
              <input
                type="text"
                class="search-input-header"
                v-model="searchQuery"
                :placeholder="$t('header.search_placeholder')"
                autocomplete="off"
                name="header-search"
                id="header-search"
                @input="handleSearchInput"
              />
                <a href="#" class="search-wrapper">
                  <img :src="iconsearch" class="icon-search" alt="Search Icon" />
                </a>
              </div>

              <div
                class="results"
                v-show="showResults && searchQuery.trim().length > 0" 
                ref="resultsContainer"
              >
                <div class="results-inner">


                   <div
                    v-if="isDelegue && !selectedVeterinarian"
                    class="no-results"
                  >
                    Veuillez sélectionner un vétérinaire d'abord
                  </div>
                  <!-- Empty state: Show when no results -->
                  <div
                    v-if="!isSearching && filteredProducts.length === 0 && filteredGammes.length === 0 && filteredTagProducts.length === 0"
                    class="no-results"
                  >
                    Aucun résultat pour cette recherche
                  </div>

                  <!-- Loading state -->
                  <div v-if="isSearching && filteredProducts.length === 0 && filteredGammes.length === 0 && filteredTagProducts.length === 0" class="loading-state">
                    Recherche en cours...
                  </div>

                  <div
                    class="result-item"
                    v-for="product in filteredProducts"
                    :key="product.id"
                    @click="GoToProduct(product)"
                  >
                    <div class="product-card">
                      <div class="left-product-card d-flex">
                        <div class="product-image">
                          <img
                            :src="
                              product.imagesDetails &&
                              product.imagesDetails.length > 0 &&
                              product.imagesDetails[0]?.path
                                ? product.imagesDetails[0].path
                                : ProductDefault
                            "
                            class="img-product"
                            alt="Product Image"
                          />
                        </div>
                        <div class="product-info mx-2">
                          <span class="gamme">{{ product.name ?? "" }} </span>
                          <h3 class="title">{{ product.inventoryName }}</h3>
                          <p class="mb-1">{{ product.gamme_supplyvet ??  "" }}</p>
                          <!-- <span v-if="product.ref">
                            {{ $t("search_product_component.labels.ref") }} {{ product.ref }}
                          </span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Tag AllProducts -->
                  <div
                    class="result-item"
                    v-for="tagProduct in filteredTagProducts"
                    :key="'tag-' + tagProduct.id"
                    @click="GoToProduct(tagProduct)"
                  >
                    <div class="product-card">
                      <div class="left-product-card d-flex">
                        <div class="product-image">
                          <img
                            :src="
                              tagProduct.imagesDetails &&
                              tagProduct.imagesDetails.length > 0 &&
                              tagProduct.imagesDetails[0]?.path
                                ? tagProduct.imagesDetails[0].path
                                : ProductDefault
                            "
                            class="img-product"
                            alt="Product Image"
                          />
                        </div>
                        <div class="product-info mx-2">
                          <span class="gamme">{{ tagProduct.name ?? "" }}</span>
                          <h3 class="title">{{ tagProduct.inventoryName }}</h3>
                          <p class="mb-1">{{ tagProduct.gamme_supplyvet ?? tagProduct.gamme ?? "" }}</p>
                          <!-- <span v-if="tagProduct.ref">
                            {{ $t("search_product_component.labels.ref") }} {{ product.ref }}
                          </span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Gammes -->
                  <div
                    class="result-item gamme-item"
                    v-for="g in filteredGammes"
                    :key="'g-' + g.id"
                    @click="GoToGamme(g)"
                  >
                    <div class="product-card">
                      <div class="left-product-card d-flex">
                        <div class="product-image gamme-icon d-flex align-items-center justify-content-center">📂</div>
                        <div class="product-info mx-2">
                          <h3 class="title">{{ g.name }}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

             

            </div>

            <div class="contact-b" v-show="!isFixed">
              <div class="bloc-contact">
                <RouterLink to="/contact" class="btn btn-contact">{{ $t("header.contact") }}</RouterLink>
              </div>
            </div>

            <!-- Contact Icon -->
            <div class="contact-inf" v-show="isFixed">
              <div class="bloc-contact">
                <RouterLink to="/contact" class="btn btn-contact-icon">
                  <span class="single-icon d-flex"
                    ><img :src="require('@/assets/images/phone.svg')" alt="Contact"
                  /></span>
                </RouterLink>
              </div>
              <!-- User Info -->
              <div class="user-info account-block me-2">
                <router-link
                  to="/mon-compte"
                  class="blue-color text-decoration-none"
                  :class="{ 'd-block': user.role == 'veterinaire', 'd-flex': user.role == 'client' }"
                >
                  <div class="d-flex gap-2 align-items-center" style="max-height: 20px">
                    <img :src="iconuser" alt="User Icon" />
                    <template v-if="user.role == 'veterinaire'">
                      <span class="px-1 font-bold d-none d-md-inline">{{ $t("header.clinic") }}</span>
                    </template>
                    <div v-else class="d-none d-md-block">
                      <span class="px-1 font-bold">{{ $t("header.hello") }}</span>
                      <span class="px-1 font-bold">{{ user.gender }} {{ user.fullName }}</span>
                    </div>
                  </div>
                </router-link>
              </div>

              <!-- Cart & Favorites -->
              <div class="cart-menu d-flex">
                <div class="sinlge-bar shopping me-2 me-lg-3" @click.prevent="GoToFavorites">
                  <a href="#" class="single-icon position-relative text-decoration-none">
                    <img :src="iconfav" alt="Favorites" />
                    <span class="total-count" v-if="CountFavorite > 0">{{ CountFavorite }}</span>
                  </a>
                </div>
                <div class="sinlge-bar shopping" @click.prevent="GoToCart">
                  <a href="#" class="single-icon position-relative text-decoration-none">
                    <img :src="iconcart" alt="Cart" />
                    <span class="total-count" v-if="CountCart > 0">{{ CountCart }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import iconuser from "@/assets/user.svg";
  import iconcart from "@/assets/cart.svg";
  import iconfav from "@/assets/fav.svg";
  import iconsearch from "@/assets/search-white.png";
  import arrowdown from "@/assets/images/icon-row-down.svg";
  import logo from "../assets/images/2_LOGO - COULEURS.png";
  import { mapStores } from "pinia";
  import { useRegisterStore } from "@/stores/register";
  import { useProductsStore } from "@/stores/productsStore";
  import { useCartStore } from "@/stores/cartStore";
  import { useGammesStore } from "@/stores/gammesStore";
  import { useBannerStore } from "@/stores/bannerStore";
  import { useMenusStore } from "@/stores/menusStore";
  import { SUPPLYVET_CHANNEL, ESUPPLYVET_CHANNEL } from "@/api/menus";
  import BannerComponent from "@/components/common/layout/Banner.vue";
  import { ref, onMounted, onUnmounted, nextTick } from "vue";
  import { useRouter } from "vue-router";
  import { searchProductsByTagHeaderOrName } from "@/api/auth";
  import { debounce } from 'lodash';
import { useDelegueStore } from '@/stores/delegueStore';
  export default {
    data() {
      return {
        gammesStore: null,
        gammes: [],
        menusStore: null,
        searchQuery: "",
        iconsearch,
        iconuser,
        arrowdown,
        logo,
        iconcart,
        iconfav,
        activeMegaMenu: null,
        timeout: null,
        registerStore: null,
        bannerStore: null,
        faqStore: null,
        NbFavorite: 0,
        NbCart: 0,
        filteredProducts: [],
        filteredGammes: [],
        filteredTagProducts: [],
        ProductDefault: require("@/assets/images/product_default.png"),
        showMobileNav: false,
        mobileOpenIndex: null,
         isSearching: false,
         productStore: null,
      };
    },
    methods: {
      showMegaMenu(index) {
        clearTimeout(this.timeout);
        this.activeMegaMenu = index;
      },
      hideMegaMenu() {
        this.timeout = setTimeout(() => {
          this.activeMegaMenu = null;
        }, 200);
      },
      GoToDashboard() {
        this.router.push({ name: "dashboard-home" });
      },
      GoToFavorites() {
        this.router.push({ name: "favorite-products" });
      },
      GoToCart() {
        this.router.push({ name: "my-cart" });
      },
      getRelAttributes(menuItem) {
        const relAttributes = [];
        if (menuItem.noreferrer) {
          relAttributes.push("noreferrer");
        }
        if (menuItem.noopener) {
          relAttributes.push("noopener");
        }
        if (menuItem.nofollow) {
          relAttributes.push("nofollow");
        }
        return relAttributes.join(" ");
      },

        async searchProductsAndGammes() {
        const query = this.searchQuery.toLowerCase().trim();

        if (!query) {
          this.resetSearch();
          if (this.abortController) this.abortController.abort(); // Cancel any pending request on clear
          return;
        }

         if (this.isDelegue && !this.selectedVeterinarian) {
            this.isSearching = false;
            this.filteredProducts = [];
            this.filteredGammes = [];
            this.filteredTagProducts = [];
            return;
          }

        // Cancel the previous request, if it exists
        if (this.abortController) {
          this.abortController.abort();
        }
        // Create a new controller for this new search
        this.abortController = new AbortController();

        this.isSearching = true;
        this.filteredProducts = [];
        this.filteredGammes = []; 
        this.filteredTagProducts = [];

        try {

          const registerStore = useRegisterStore();
         const delegueStore = useDelegueStore();
         const userRole = registerStore.user?.role || "";
         const isDelegue = userRole === "delegues";
         const vetId = isDelegue ? delegueStore.getSelectedVeterinarian?.id : null;

          if (isDelegue && !vetId) {
            this.isSearching = false;
            this.filteredProducts = [];
            this.filteredGammes = [];
            this.filteredTagProducts = [];
            return;
          }
          // Pass the signal from the new controller to the API function
          const apiResults = await searchProductsByTagHeaderOrName(query, { signal: this.abortController.signal },isDelegue, vetId);

          // IMPORTANT: Check if the request was aborted while we were waiting.
          // The signal might have been aborted after the request finished but before this code runs.
          if (this.abortController.signal.aborted) {
            return; // If it was aborted, just exit without updating the UI.
          }

          // If we get here, the request was NOT aborted and completed successfully.
          this.filteredProducts = Array.isArray(apiResults) ? apiResults : [];
          // Remove duplicates (your API function already does this, but this is a safe fallback)
          this.filteredProducts = this.filteredProducts.filter((product, index, self) =>
            index === self.findIndex(p => p.id === product.id)
          );

        } catch (error) {
          // Only log the error if it wasn't an abort error
          if (error.name !== 'CanceledError' && error.name !== 'AbortError') {
            console.error("API search failed:", error);
            this.filteredProducts = [];
          }
        } finally {
          // This runs whether the request succeeded, failed, or was aborted.
          // Only stop the loading spinner if this specific request was NOT aborted.
          if (this.abortController && !this.abortController.signal.aborted) {
            this.isSearching = false;
          }
        }

        // Filter gammes locally (this is fast and synchronous, no need for abort checks)
        this.filteredGammes = this.gammesStore.gammes.filter(g =>
          g.name?.toLowerCase().includes(query)
        );
        // Apply the same deduplication logic if necessary
        this.filteredGammes = this.filteredGammes.filter((gamme, index, self) =>
          index === self.findIndex(g => g.id === gamme.id)
        );
      },
      resetSearch() {
        this.filteredProducts = [];
        this.filteredGammes = [];
        this.filteredTagProducts = []; 
        this.isSearching = false;
        // Also abort any ongoing request when resetting
        if (this.abortController) {
          this.abortController.abort();
        }
      },
      GoToProduct(product) {
        this.router.push({ name: "ProductDetail", params: { slug: product.slug } });
        this.resetSearch();
      },
      GoToGamme(gamme) {
        const slug = `${gamme.id}-${gamme.slug}`;
        this.$router.push({ name: "taxonList", params: { slug } });
      },

      toggleMobileNav() {
        this.showMobileNav = !this.showMobileNav;
        if (!this.showMobileNav) {
          this.mobileOpenIndex = null;
        }
        document.body.style.overflow = this.showMobileNav ? "hidden" : "";
      },
      handleMobileNavClick(menuItem, index, event) {
        if (menuItem.children && menuItem.children.length > 0) {
          event.preventDefault();
          this.mobileOpenIndex = this.mobileOpenIndex === index ? null : index;
        } else {
          this.toggleMobileNav();
        }
      },
    },
    name: "AppHeader",
    components: {
      BannerComponent,
    },

    setup() {
      const isFixed = ref(false);
      const resultsContainer = ref(null);
      const SearchInput = ref(null);
      const showResults = ref(false);
      const router = useRouter();
      const $isMobile = ref(window.innerWidth < 768);

      const handleClickOutside = event => {
        if (
          resultsContainer.value &&
          !resultsContainer.value.contains(event.target) &&
          SearchInput.value &&
          !SearchInput.value.contains(event.target)
        ) {
          showResults.value = false;
        }
      };

      const handleResize = () => {
        $isMobile.value = window.innerWidth < 768;
      };

      const handleScroll = () => {
        if ($isMobile.value) {
          isFixed.value = false;
        } else {
          isFixed.value = window.scrollY > 20;
        }
      };

      onMounted(() => {
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        document.addEventListener("mousedown", handleClickOutside);
      });

      onUnmounted(() => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
        document.removeEventListener("mousedown", handleClickOutside);
      });

      return {
        isFixed,
        $isMobile,
        resultsContainer,
        SearchInput,
        showResults,
        router,
      };
    },
    computed: {
      ...mapStores(useProductsStore, useCartStore),
      favoriteStore() {
        return useProductsStore();
      },
      CountFavorite() {
        var count = useProductsStore().countFavorite;
        if (count === undefined || count === null) {
          useProductsStore().fetchProducts();
          count = useProductsStore().countFavorite;
        }
        return count;
      },
      CountCart() {
        var count = useCartStore().CountCart;
        if (count === undefined || count === null) {
          useCartStore().fetchCart();
          count = useCartStore().CountCart;
        }
        return count;
      },
      user() {
        return this.registerStore.user;
      },
      company() {
        if (this.registerStore.VeterinaireInfo?.lastName) {
          return this.registerStore.VeterinaireInfo.lastName;
        }
        if (this.registerStore.Veterinaire?.lastName) {
          return this.registerStore.Veterinaire.lastName;
        }
        if (this.registerStore.VeterinaireInfo?.fullName) {
          return this.registerStore.VeterinaireInfo.fullName;
        }
        return "Ma clinique";
      },
      veterinaire() {
        if (this.registerStore.VeterinaireInfo?.address_infos) {
          return this.registerStore.VeterinaireInfo.address_infos;
        }
        if (this.registerStore.Veterinaire?.adressesFacturation) {
          return this.registerStore.Veterinaire.adressesFacturation;
        }
        return {
          street: "",
          postcode: "",
          city: "",
        };
      },
      banner() {
        return this.bannerStore.activeBanner(this.user?.role);
      },
      menuItems() {
        if (!this.menusStore) return [];
        
        return this.menusStore.sortedMenuItems
          .filter(item => item.active === true)
          .map(item => ({
            ...item,
            children: item.children ? item.children.filter(child => child.active === true) : []
          }));
      },
      isDelegue() {
        return this.user?.role === "delegues";
      },
      selectedVeterinarian() {
        const delegueStore = useDelegueStore();
        return delegueStore.getSelectedVeterinarian;
      }
    },
    created() {
      this.registerStore = useRegisterStore();
      this.registerStore.fetchVeterinaire();

      this.productStore = useProductsStore();
      this.productStore.fetchFavoriteProducts();
      this.bannerStore = useBannerStore();
      this.bannerStore.fetchBanners(this.user?.role);
       this.debouncedSearch = debounce(this.searchProductsAndGammes, 400);

      const RoutesCart = ["my-cart"];
      const RoutesProducts = ["my-cart", "dashboard-home", "supplyvet-products", "favorite-products", "ProductDetail"];

      if (!RoutesCart.includes(this.$route.name)) {
        var cart = useCartStore();
        cart.fetchCart();
      }
      if (!RoutesProducts.includes(this.$route.name)) {
        var productsStore = useProductsStore();
        productsStore.fetchProducts();
      }

      this.menusStore = useMenusStore();
      nextTick(() => {
        if (this.user && this.user.role === "client") {
          this.menusStore.fetchMenus(ESUPPLYVET_CHANNEL);
        } else {
          this.menusStore.fetchMenus(SUPPLYVET_CHANNEL);
        }
      });

      this.gammesStore = useGammesStore();
      this.gammesStore.fetchGammes();
      this.gammes = this.gammesStore.gammes.slice().sort((a, b) => a.id - b.id);
    },

    watch: {
      searchQuery(newVal) {
      if (!newVal.trim()) {
        this.showResults = false;
        this.resetSearch();
        return;
      }
      this.showResults = true;
      this.isSearching = true;
      this.debouncedSearch();
    },
    },
  };
</script>
<style scoped>
  /* Hamburger menu styles */
  .hamburger-menu {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
}

.hamburger-menu span {
  display: block;
  width: 24px;
  height: 2px;
  background-color: #1e347d;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Transform to X when menu is open */
.hamburger-menu span:nth-child(1).open {
  transform: rotate(45deg) translate(9px, 9px);
}

.hamburger-menu span:nth-child(2).open {
  opacity: 0;
}

.hamburger-menu span:nth-child(3).open {
  transform: rotate(-45deg) translate(7px, -7px);
}
  @media (min-width: 992px) {
    .hamburger-menu {
      display: none;
    }
  }

  /* Mobile nav overlay */
  .mobile-nav-fade-enter-active,
  .mobile-nav-fade-leave-active {
    transition: opacity 0.2s;
  }
  .mobile-nav-fade-enter-from,
  .mobile-nav-fade-leave-to {
    opacity: 0;
  }
  .mobile-nav {
    position: fixed;
    top: 45px;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.98);
    z-index: 2001;
    overflow-y: auto;
    padding-top: 60px;
  }
  .mobile-navbar-nav {
    list-style: none;
    padding: 0 1.5rem;
    margin: 0;
  }
  .mobile-nav-item {
    border-bottom: 1px solid #e0e0e0;
  }
  .mobile-nav-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 3rem;
    color: #1e347d;
    font-size: 1.1rem;
    font-weight: 500;
    text-decoration: none;
  }
  .mobile-arrow {
    margin-left: 8px;
    display: flex;
    align-items: center;
  }
  .mobile-submenu {
    list-style: none;
    padding: 0 3rem !important;
    margin: 0.5rem 0 1rem 0;
  }
  .mobile-submenu-link {
    display: block;
    padding: 0.5rem 0;
    color: #1e347d;
    font-size: 1rem;
    text-decoration: none;
  }
  .mobile-submenu-link:hover {
    text-decoration: underline;
  }

  @media (min-width: 768px) {
    .mobile-nav,
    .hamburger-menu {
      display: none !important;
    }
  }

  @media (max-width: 767px) {
    .single-header-content,
    .single-header-content.is-fixed {
      padding: 8px 0 8px 48px;
    }
    .header-spacer,
    .header-spacer.has-banner {
      height: 48px;
    }

    .mobile-nav.has-banner {
      top: 80px !important;
    }

    .logo-site {
      height: 35px !important;
      position: absolute;
      top: 10%;
    }

    .cart-menu {
      margin: 10px 5px;
    }
    .form-search-header {
      width: 80vw;
      max-width: 80vw;
      margin: 0 0 0 -16px;
      padding: 0 8px;
      position: relative;
      z-index: 10;
    }
    .search-input-header {
      height: 32px;
      font-size: 1rem;
      padding: 0 36px 0 12px;
      border-radius: 18px;
      width: 100%;
      box-sizing: border-box;
    }
    .search-wrapper {
      width: 28px;
      height: 28px;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
    }
    .icon-search {
      width: 16px;
      height: 16px;
    }
    .results {
      font-size: 12px;
      border-radius: 0 0 8px 8px;
      left: 0;
      width: 100vw;
      min-width: 0;
      max-width: 100vw;
    }
    .result-item {
      padding: 6px 8px;
    }
    .product-image {
      width: 28px;
      height: 28px;
      padding: 2px;
    }
    .product-info {
      margin-left: 4px;
    }
    .product-info .title {
      font-size: 10px;
    }
    .product-info .gamme {
      font-size: 9px;
    }
    .product-info p {
      font-size: 9px;
    }
    .gamme-item .product-image.gamme-icon {
      font-size: 10px;
    }
    .gamme-item .title {
      font-size: 10px;
    }
    .btn-contact {
      display: none !important;
    }
    .bloc-contact .btn-contact-icon .single-icon img {
      width: 8px;
      height: 8px;
    }
    .total-count {
      width: 8px;
      height: 8px;
      line-height: 8px;
      font-size: 5px;
      top: -2px;
      right: -2px;
    }
    .single-header-content.is-fixed .total-count {
      width: 6px;
      height: 6px;
      line-height: 6px;
      font-size: 4px;
      top: -1px;
      right: -1px;
    }
    .navbar-nav {
      display: none !important;
    }
  }
  .site-header {
    position: relative;
    width: 100%;
    background-color: #fff;
    padding: 0;
    z-index: 1000;
    box-sizing: border-box;
    margin-bottom: 4rem;
  }

  .header-spacer {
    height: 76px;
  }

  .header-spacer.has-banner {
    height: calc(76px + 34px);
  }

  .single-header-content {
    position: fixed;
    background-color: white;
    top: 0;
    right: 0;
    left: 0;
    padding: 13px 50px;
    z-index: 1001;
    box-sizing: border-box;
    width: 100%;
    transition:
      padding 0.3s ease,
      background-color 0.3s ease,
      box-shadow 0.3s ease;
  }

  .single-header-content.has-banner {
    top: 34px;
  }

  .single-header-content.is-fixed {
    background-color: white;
    padding: 20px 50px;
  }

  .brand-logo {
    cursor: pointer;
    flex-shrink: 0;
  }

  .logo-site {
    height: 50px;
    width: auto;
    transition: all 0.3s ease;
  }

  .single-header-content.is-fixed .logo-site {
    height: 30px;
  }

  .header-nav-block {
    flex-grow: 1;
    min-width: 0;
  }

  .navbar-nav {
    gap: 1px !important;
  }

  .nav-link {
    color: #1e347d !important;
    font-weight: 500;
    padding: 0.5rem 0.75rem !important;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    white-space: nowrap;
  }

  .nav-link:hover {
    background-color: rgba(30, 52, 125, 0.1);
    text-decoration: none;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .arrow-icon {
    transition: transform 0.3s ease;
    width: 16px;
    height: 16px;
    margin-left: 5px;
  }

  .arrow-icon.rotate-180 {
    transform: rotate(180deg);
  }

  .single-header-content.is-fixed .nav-link {
    padding: 0.25rem 0.5rem;
  }

  .mega-menu {
    border: 0 !important;
    border-radius: 0 !important;
    background-color: #ffffff;
    z-index: 1050;
    width: 100vw;
    box-sizing: border-box;
    left: 0;
    padding: 0;
    margin: 0;
  }

  .dropdown-menu.mega-menu.position-fixed {
    position: fixed !important;
    top: calc(134px + 34px);
    left: 0;
    right: 0;
    z-index: 1050;
    display: block;
    margin-top: 0;
  }

  .single-header-content.is-fixed .dropdown-menu.mega-menu.position-fixed {
    top: calc(40px + 34px);
  }

  .dropdown-menu.mega-menu.position-no-banner {
    position: fixed !important;
    top: 132px;
    left: 0;
    right: 0;
    z-index: 1050;
    display: block;
    margin-top: 0;
  }

  .single-header-content.is-fixed .dropdown-menu.mega-menu.position-no-banner {
    top: 90px;
  }

  .mega-menu .container {
    width: 100%;
    max-width: 95%;
    margin: 0 auto;
    padding: 1rem 0;
  }

  .menu-links {
 
  }

  .menu-links a {
    display: block;
    padding: 0.5rem 1rem;
    color: #1e347d !important;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    text-decoration: none;
    width: 100%;
  }

  .menu-links a:hover {
    background-color: rgba(30, 52, 125, 0.1);
    text-decoration: none;
  }

  .form-search-header {
    position: relative;
    width: 443px;
    margin: 0 0.5rem;
    flex-shrink: 1;
  }

  .search-input-header {
    width: 100%;
    max-width: 100%;
    height: 40px;
    background: #ffffff 0% 0% no-repeat padding-box;
    padding: 0 45px 0 15px;
    border: 1px solid #aeb1ba;
    border-radius: 25px;
    outline: none;
    box-sizing: border-box;
    font-size: 1rem;
  }

  .search-wrapper {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    background-color: #ec621a;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .single-header-content.is-fixed .search-wrapper {
    width: 25px;
    height: 25px;
  }

  .icon-search {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }

  .single-header-content.is-fixed .icon-search {
    width: 15px;
    height: 15px;
  }

  .results {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #aeb1ba;
    border-top: none;
    border-radius: 0 0 25px 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 999;
    max-height: 70vh;
    overflow-y: auto;
    margin-top: 2px;
  }

  .results-inner {
  }

  .result-item {
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .result-item:last-child {
    border-bottom: none;
    border-radius: 0 0 25px 25px;
  }

  .result-item:hover {
    background-color: #f7f7f7;
  }

  .product-card {
    display: flex;
    align-items: center;
  }

  .left-product-card {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .product-image {
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 10px;
    overflow: hidden;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-product {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .product-info {
    margin-left: 15px;
    flex-grow: 1;
    min-width: 0;
  }

  .product-info .gamme {
    color: #1e347d;
    font-size: 13px;
    font-weight: 500;
  }

  .product-info .title {
    font-size: 15px;
    font-weight: bold;
    color: #1e347d;
    margin: 3px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .product-info p {
    margin: 0 0 5px 0;
    font-size: 13px;
    color: #555;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .gamme-item .product-image.gamme-icon {
    font-size: 28px;
    color: #ec621a;
    background-color: #f3f3f3;
  }

  .gamme-item .title {
    font-size: 15px;
    font-weight: bold;
    color: #ec621a;
  }

  .bloc-contact {
    margin: 10px;
  }

  .bloc-contact .btn-contact-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    border-radius: 50%;
    background-color: #f0f0f0;
    transition: background-color 0.2s ease;
    text-decoration: none;
  }

  .bloc-contact .btn-contact-icon:hover {
    background-color: #e0e0f0;
    text-decoration: none;
  }

  .bloc-contact .btn-contact-icon .single-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1e347d;
    font-size: 20px;
  }

  .bloc-contact .btn-contact-icon .single-icon img {
    width: 20px;
    height: 20px;
  }

  .single-header-content.is-fixed .bloc-contact .btn-contact-icon {
    padding: 0.3rem;
  }

  .single-header-content.is-fixed .bloc-contact .btn-contact-icon .single-icon img {
    width: 18px;
    height: 18px;
  }

  .user-info .font-bold {
    font-weight: bold;
  }

  .account-block a {
    text-decoration: none;
    color: inherit;
  }

  .account-block a:hover {
    text-decoration: none;
  }

  .single-header-content.is-fixed .account-block .d-none.d-md-block {
    display: none;
  }

  .cart-menu {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .sinlge-bar.shopping {
    cursor: pointer;
  }

  .sinlge-bar.shopping:first-child {
    margin-left: 0;
  }

  .single-icon {
    color: #1e347d;
    font-size: 20px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .single-icon img {
    width: 20px;
    height: 20px;
  }

  .total-count {
    position: absolute;
    top: -8px;
    right: -12px;
    background: #1e347d;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    border-radius: 100%;
    font-size: 11px;
    font-weight: bold;
  }

  .single-header-content.is-fixed .total-count {
    top: -6px;
    right: -10px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .second-part {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .no-banner-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }
  .banner-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }

  .dyno-info-2 {
  }

  .alpha-top {
    display: flex;
    justify-content: space-between;
    margin: 0 0 5px 0;
  }

  .beta-top {
    display: flex;
    justify-content: space-between;
  }

  .btn-contact {
    background: #c9cfde 0% 0% no-repeat padding-box;
    border-radius: 50px;
    font-size: 16px;
    padding: 8px 15px;
    text-align: center;
    font: normal normal bold 16px/25px DM Sans;
    letter-spacing: 0px;
    color: #1e347d;
    width: 170px;
  }

  .contact-inf {
    display: flex;
    align-items: center;
  }

  .no-results, .loading-state {
    padding: 20px 15px;
    text-align: center;
    color: #888;
    font-size: 14px;
    font-style: italic;
  }

  .no-results:hover, .loading-state:hover {
    background-color: transparent; /* No hover effect for empty/loading state */
  }

  /* Mobile adjustments for empty/loading state */
  @media (max-width: 767px) {
    .no-results, .loading-state {
      padding: 12px 8px;
      font-size: 12px;
    }
  }
</style>
